







































































































import 'reflect-metadata'
import { Vue, Component, Prop } from 'vue-property-decorator'
import Subnet from '@/js/Subnet'
import { AVALANCHE_SUBNET_ID } from '@/store/modules/platform/platform'
import ContentMetadata from '@/components/Subnets/ContentMetadata.vue'
import ValidatorDataTable from '@/components/Validators/ValidatorDataTable.vue'
import BlockchainDataTable from '@/components/Blockchain/BlockchainDataTable.vue'
import DelegationDataTable from '@/components/Validators/DelegationDataTable.vue'
import ControlKeyTable from '@/components/Validators/ControlKeyTable.vue'

@Component({
    components: {
        ContentMetadata,
        ValidatorDataTable,
        BlockchainDataTable,
        ControlKeyTable,
        DelegationDataTable,
    },
})
export default class Content extends Vue {
    dense = true
    fixedHeader = true
    defaultSubnetID: string = AVALANCHE_SUBNET_ID
    currentTime: number | null = null
    startTimes: number[] = []
    endTimes: number[] = []
    minTime = 0
    maxTime = 1
    absolute = false

    @Prop() subnetID!: string
    @Prop() subnet!: Subnet

    get mode(): string {
        return this.absolute ? 'absolute' : 'relative'
    }

    get modeText() {
        return this.absolute ? 'Timeline' : 'Completion'
    }

    get tab() {
        return this.$route.query.tab
    }

    set tab(tab: string | (string | null)[]) {
        this.$router.replace({ query: { ...this.$route.query, tab } })
    }
}
